import React, {useEffect, useMemo, useState} from 'react';

import {useParams} from "react-router-dom";
import Loader from "react-loader";
import {NotificationManager} from 'react-notifications';
import ClientForm from '../../../shared/components/admin/forms/ClientForm';
import ClientService from '../../../services/ClientService';
import { Client } from '../../../models/Client';

export default () => {
    const {id = null} = useParams<any>();
    const [loaded, setLoaded] = useState<boolean>(!id)
    const [formData, setFormData] = useState<Client | null>(null)

    useEffect((): void => {
        id && ClientService.client(Number(id)).then(c => {
            c && setFormData(() => c)
            setLoaded(true)
        })
    }, [id])

    const method: (model: Client) => Promise<Client | null> = useMemo(() =>
            id ? ClientService.update : ClientService.store,
        [id, ClientService]
    )

    const handleSubmitForm = (c: Client): void => {
        setFormData(() => c)
        setLoaded(false)
        method(c).then(response => {
                if (response) {
                    NotificationManager.success('Klient zapisany pomyślnie.')
                    window.location.href = '/admin/clients'
                } else {
                    NotificationManager.error('Nie udało się zapisać klienta.')
                    setLoaded(true)
                }
            }
        )
    }

    return (
        <Loader loaded={loaded}>
            <ClientForm clientData={formData} onSubmitForm={handleSubmitForm}/>
        </Loader>
    )
}